import { GlobalStyles as MuiGlobalStyles, useTheme } from '@mui/material';
import React, { FC } from 'react';
export const GlobalStyles: FC = () => {
  const theme = useTheme();

  const styles = {
    '.MuiTypography-root': {
      letterSpacing: '0.1px',
    },

    '.react-select .react-select__control.react-select__control--is-disabled': {
      background: theme.palette.secondary.dark,
      WebkitTextFillColor: theme.palette.text.disabled,
    },

    '.MuiSwitch-root.MuiSwitch-sizeMedium': {
      display: 'flex',
      width: theme.spacing(3.5),
      height: theme.spacing(2),
      padding: theme.spacing(0),
      marginRight: theme.spacing(1),
      overflow: 'visible',

      '&:active': {
        '& .MuiSwitch-thumb': {
          width: theme.spacing(1.875),
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
          transform: `translateX(${theme.spacing(1.375)})`,
        },
      },

      '&:focus': {
        '& .MuiSwitch-thumb': {
          boxShadow: '0 0 0 0.2rem rgb(110 3 246 / 25%)',
        },
      },

      '& .MuiSwitch-switchBase': {
        padding: theme.spacing(0.25),
        '&.Mui-checked': {
          transform: `translateX(${theme.spacing(1.375)})`,
          color: theme.palette.text.primary,
          '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: theme.palette.primary.main,
            border: 'none',
          },
        },

        '&.Mui-disabled': {
          color: theme.palette.grey[600],

          '& + .MuiSwitch-track': {
            opacity: 0.5,
          },
        },
      },
      '& .MuiSwitch-thumb': {
        width: theme.spacing(1.5),
        height: theme.spacing(1.5),
        borderRadius: theme.spacing(0.75),
        transition: theme.transitions.create(['width'], {
          duration: 200,
        }),
      },

      '& .MuiSwitch-track': {
        borderRadius: theme.spacing(1),
        opacity: 1,
        backgroundColor: 'transparent',
        boxSizing: 'border-box',
        border: `${theme.spacing(0.125)} solid ${theme.palette.text.primary}}`,
      },
    },
  };

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <MuiGlobalStyles styles={styles} />;
};
